import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { GrantSlackAccessInput_InputAdapter_instance2xotdiilmjotr as GrantSlackAccessInput_InputAdapter_instance } from '../type/adapter/GrantSlackAccessInput_InputAdapter.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var GrantSlackAccessMutation_VariablesAdapterClass;
function GrantSlackAccessMutation_VariablesAdapter() {
  if (GrantSlackAccessMutation_VariablesAdapterClass === VOID) {
    class $ {
      a6g(writer, value, customScalarAdapters, withDefaultValues) {
        writer.n4a('input');
        obj(GrantSlackAccessInput_InputAdapter_instance).t3x(writer, customScalarAdapters, value.z6f_1);
      }
    }
    initMetadataForObject($, 'GrantSlackAccessMutation_VariablesAdapter');
    GrantSlackAccessMutation_VariablesAdapterClass = $;
  }
  return GrantSlackAccessMutation_VariablesAdapterClass;
}
var GrantSlackAccessMutation_VariablesAdapter_instance;
function GrantSlackAccessMutation_VariablesAdapter_getInstance() {
  return GrantSlackAccessMutation_VariablesAdapter_instance;
}
//region block: init
GrantSlackAccessMutation_VariablesAdapter_instance = new (GrantSlackAccessMutation_VariablesAdapter())();
//endregion
//region block: exports
export {
  GrantSlackAccessMutation_VariablesAdapter_instance as GrantSlackAccessMutation_VariablesAdapter_instance70s4jr9spry0,
};
//endregion

//# sourceMappingURL=GrantSlackAccessMutation_VariablesAdapter.mjs.map
